import React from 'react';
import GanttChart from './GanttChart';

const Schedule = ({ timeline, rule, WebGL, clickedChild, treeData, setTreeData }) => {
  return (
    <GanttChart 
      timeline={timeline} 
      rule={rule} 
      WebGL={WebGL}
      clickedChild={clickedChild}
      treeData={treeData}
      setTreeData={setTreeData}
    />
  );
};

export default Schedule;